import { MediaQueries } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px;

  width: 100%;
  height: 100%;

  border: 0.5px solid #e4e8ec;
  box-sizing: border-box;
  border-radius: 6px;
  a {
    text-decoration: none;
  }
  &:hover {
    box-shadow: 0px 5px 5px rgba(40, 74, 117, 0.08);
    transition: ease-out 0.3s;
  }
`

export const StyledTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 70%;

  ${MediaQueries.mbDown} {
    width: 50%;
  }
`

export const StyledDescription = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 36px;
`

export const StyledResult = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
`
